(() => {
  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = text;
    return element;
  };

  const setText = (root, selector, value) => {
    const element = root.querySelector(selector);
    if (element && value !== undefined && value !== null) element.textContent = value;
  };

  const setLink = (element, url) => {
    if (url) element.setAttribute('href', url);
  };

  const replaceMedia = (media, item, imageClass) => {
    if (!media || !item.image) return;
    const image = createElement('img', imageClass);
    image.src = item.image;
    image.alt = item.title || '';
    image.loading = 'lazy';
    media.replaceChildren(image);
  };

  const renderMobileRoutes = (config) => {
    const container = document.querySelector('[data-kmc-mobile-menu-server] .kmc-mobile-phase1__routes');
    if (!container) return;

    const routes = Array.isArray(config.routes) ? config.routes : [];
    if (!config.enableMobileMenu) {
      container.closest('[data-kmc-mobile-menu-server]').hidden = true;
      return;
    }

    container.closest('[data-kmc-mobile-menu-server]').hidden = false;
    if (!routes.length) return;

    const fragment = document.createDocumentFragment();
    routes.forEach((route) => {
      const card = createElement('a', 'kmc-mobile-route-card');
      setLink(card, route.url);

      const media = createElement('span', 'kmc-mobile-route-card__media');
      if (route.image) {
        replaceMedia(media, route, 'kmc-mobile-route-card__img');
      } else {
        media.append(createElement('span', 'kmc-mobile-route-card__fallback', route.fallback || 'KMC'));
      }

      const copy = createElement('span', 'kmc-mobile-route-card__copy');
      copy.append(
        createElement('span', 'kmc-mobile-route-card__kicker', route.kicker || ''),
        createElement('span', 'kmc-mobile-route-card__title', route.title || ''),
        createElement('span', 'kmc-mobile-route-card__sub', route.sub || '')
      );
      card.append(media, copy);
      fragment.append(card);
    });
    container.replaceChildren(fragment);
  };

  const renderMobileSections = (config) => {
    const container = document.querySelector('[data-kmc-mobile-menu-server] .kmc-mobile-phase1__sections');
    const sections = Array.isArray(config.mobileSections) ? config.mobileSections : [];
    if (!container || !sections.length) return;

    const fragment = document.createDocumentFragment();
    sections.forEach((section, index) => {
      const details = createElement('details', 'kmc-mobile-accordion');
      if (index === 0) details.open = true;

      const summary = createElement('summary', 'kmc-mobile-accordion__summary');
      summary.append(createElement('span', '', section.title || ''));

      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
      icon.setAttribute('viewBox', '0 0 10 6');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M1 1l4 4 4-4');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      icon.append(path);
      summary.append(icon);

      const list = createElement('ul', 'kmc-mobile-accordion__links');
      (section.links || []).forEach((link) => {
        const item = createElement('li');
        const anchor = createElement('a', '', link.title || '');
        setLink(anchor, link.url);
        item.append(anchor);
        list.append(item);
      });

      details.append(summary, list);
      fragment.append(details);
    });
    container.replaceChildren(fragment);
  };

  const renderUtilityLinks = (config) => {
    const list = document.querySelector('[data-kmc-mobile-menu-server] .kmc-mobile-shortcuts');
    const links = Array.isArray(config.utilityLinks) ? config.utilityLinks : [];
    if (!list || !links.length) return;

    const fragment = document.createDocumentFragment();
    links.forEach((link) => {
      const item = createElement('li');
      const anchor = createElement('a', '', link.title || '');
      setLink(anchor, link.url);
      item.append(anchor);
      fragment.append(item);
    });
    list.replaceChildren(fragment);
  };

  const renderMegaTiles = (config) => {
    const container = document.querySelector('[data-kmc-phase1-mega]');
    const grid = container && container.querySelector('.kmc-mega-phase1__grid');
    const tiles = Array.isArray(config.megaTiles) ? config.megaTiles : [];
    if (!container || !grid) return;

    container.hidden = !config.enableDesktopTiles;
    if (!config.enableDesktopTiles || !tiles.length) return;

    const fragment = document.createDocumentFragment();
    tiles.forEach((tile) => {
      const card = createElement('a', 'kmc-mega-tile');
      setLink(card, tile.url);

      const media = createElement('span', 'kmc-mega-tile__media');
      if (tile.image) {
        replaceMedia(media, tile, 'kmc-mega-tile__img');
      } else {
        media.append(createElement('span', 'kmc-mega-tile__fallback', tile.fallback || 'KMC'));
      }

      const copy = createElement('span', 'kmc-mega-tile__copy');
      copy.append(
        createElement('span', 'kmc-mega-tile__title', tile.title || ''),
        createElement('span', 'kmc-mega-tile__sub', tile.sub || '')
      );
      card.append(media, copy);
      fragment.append(card);
    });
    grid.replaceChildren(fragment);
  };

  const updateDesktopRouteCards = (config) => {
    const cards = document.querySelectorAll('.kmc-mega-route-stack .kmc-mega-route-card');
    const routes = Array.isArray(config.routes) ? config.routes.slice(1, 3) : [];
    cards.forEach((card, index) => {
      const route = routes[index];
      if (!route) return;
      setLink(card, route.url);
      setText(card, '.kmc-mega-route-card__kicker', route.kicker);
      setText(card, '.kmc-mega-route-card__title', route.title);
      setText(card, '.kmc-mega-route-card__sub', route.sub);
    });
  };

  const applyHeaderControls = () => {
    const config = window.KMCHeaderPhase1;
    if (!config) return;
    renderMobileRoutes(config);
    renderMobileSections(config);
    renderUtilityLinks(config);
    renderMegaTiles(config);
    updateDesktopRouteCards(config);
    document.documentElement.classList.add('kmc-header-phase1-server');
  };

  document.addEventListener('DOMContentLoaded', applyHeaderControls);
  document.addEventListener('kmc:header-config-updated', () => {
    window.requestAnimationFrame(applyHeaderControls);
  });
  document.addEventListener('shopify:section:load', () => {
    window.requestAnimationFrame(applyHeaderControls);
  });

  applyHeaderControls();
})();
